import script from "./ImageTextGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageTextGroup.vue?vue&type=script&setup=true&lang=ts"

import "./ImageTextGroup.vue?vue&type=style&index=0&id=c9331c22&lang=scss"

const __exports__ = script;

export default __exports__